'use client';

import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { Divider } from '../divider/divider';
import { verticalNavDividerStyles } from './styles/vertical-nav-divider.styles';
import type { VerticalNavDividerPropsInterface } from './types/vertical-nav-divider.types';

/**
 * @since 10.0.0
 */
export const VerticalNavDivider = forwardRef<HTMLDivElement, VerticalNavDividerPropsInterface>(
  (props: VerticalNavDividerPropsInterface, forwardedRef) => {
    const { className, css: cssProp, ...rest } = props;

    const styles = css(verticalNavDividerStyles, cssProp);

    return (
      <Divider
        ref={forwardedRef}
        data-c11n-component="VerticalNav.Divider"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', styles, className)}
        {...rest}
      />
    );
  },
);

VerticalNavDivider.displayName = 'VerticalNav.Divider';
